import { createFileRoute } from '@tanstack/react-router';
import { PeopleListPage } from '@/features/people/PeopleListPage';
import { peopleSearchSchema, readPeopleSearch, writePeopleSearch } from '@/features/people/peopleFilter';

export const Route = createFileRoute('/_authenticated/people/')({
  validateSearch: peopleSearchSchema,
  component: function PeopleList() {
    const search = Route.useSearch();
    const filter = readPeopleSearch(search);
    const navigate = Route.useNavigate();
    return (
      <PeopleListPage
        filter={filter} onFilterChange={(f) => void navigate({ search: (prev) => ({ ...writePeopleSearch(f), s: prev.s, vt: prev.vt }), replace: true })}
        roleOf={search.vt} onRoleOfClear={() => void navigate({ search: (prev) => ({ ...prev, vt: undefined }), replace: true })}
        onAdded={() => void navigate({ to: '/people/review' })}
      />
    );
  },
});
